import { GeoUtils } from '../../../../utils/geo.utils';
import { HTMLUtils } from '../../../../utils/html.utils';
import { AbstractEditTool } from './abstract-edit-tool';
import { CCanvas } from './ccanvas';
import { CImage } from './cimage';
import { FilterConfig, GLFX, GLFXCanvas, GLFXFilterConfig, GLFXFilters, GLFXFilterValueMap } from './filter.contants';
import { ImageContainer } from './image-container';
import { Photo } from './photo';

export declare var fx: GLFX;

export class Filter extends AbstractEditTool {
    sampleCanvas: GLFXCanvas = fx.canvas();
    photoModel: Photo;
    texture;

    get canvas(): GLFXCanvas {
        return this.container.getElement().querySelector<GLFXCanvas>('#carman');
    }

    constructor(photoModel: Photo, container: ImageContainer) {
        super(container);
        this.photoModel = photoModel;
    }

    /*
    init should takecare of the initial image on the container
    */
    public async load(): Promise<void> {
        this.showCanvasOnly();
        // TODO Not awaiting for the filters
        this.updateFilterSamples();
        this.fitCanvasToContainer();
        await this.applyFilterToCanvas(FilterConfig.getCurrentFilterConfig());
    }

    async updateFilterSamples() {
        let sample_holder = document.getElementById('sample_holder');
        if (!sample_holder.classList.contains('initialized')) {
            // TODO what if user want to change the uploaded image.
            // This class need to be removed
            sample_holder.classList.add('initialized');
            let glfxCanvas;
            for (let k in GLFXFilters) {
                console.time('SAMPLE');
                if (GLFXFilters.hasOwnProperty(k)) {
                    const _sampleCanvas = document.createElement('canvas');
                    _sampleCanvas.width = 100;
                    _sampleCanvas.height = 100;
                    const filter: GLFXFilterConfig = GLFXFilters[k];
                    // const filterPreviewImage = document.createElement('img');
                    // filterPreviewImage.dataset.filter = filter.name;
                    _sampleCanvas.dataset.filter = filter.name;

                    const a_filter = document.createElement('div');
                    a_filter.classList.add('text-center');
                    a_filter.classList.add(filter.name.replace(' ', '-'));
                    a_filter.dataset.filter = filter.name;
                    a_filter.style.width = '100px';
                    a_filter.style.height = '122px';
                    a_filter.addEventListener('click', () => {
                        const domEvent = new CustomEvent('filter', {
                            bubbles: true,
                        });
                        a_filter.dispatchEvent(domEvent);
                    });
                    // a_filter.appendChild(filterPreviewImage);

                    const filterNameContainer = document.createElement('span');
                    filterNameContainer.innerText = filter.name;
                    a_filter.appendChild(filterNameContainer);
                    sample_holder.append(a_filter);

                    await CImage.drawCanvasContained(_sampleCanvas, this.photoModel.getEphemeralCanvas());
                    glfxCanvas = await this.applyFilterToSample(glfxCanvas, filter, _sampleCanvas);
                    a_filter.prepend(glfxCanvas);

                    glfxCanvas.replaceWith(await CImage.canvasToImage(glfxCanvas));

                    /*const fn = (c) => {
                        setTimeout(
                            async () => {
                            },
                            0
                        );
                    }
                    fn(glfxCanvas);
                    */
                    // Load a canvas with this.image
                    //      image must be placed as cover
                }
                console.timeEnd('SAMPLE');
            }

        }
    }

    private fitCanvasToContainer() {
        this.getContainer().fitContainerToParent();
        const containerRect = HTMLUtils.getElementBoundingRectangle(this.getContainer().getElement());
        const imgRect = HTMLUtils.getCanvasNatualDimension(this.photoModel.getEphemeralCanvas());
        const rect = GeoUtils.containAbsolutePositionedChild(containerRect, imgRect);

        HTMLUtils.css(this.canvas, 'top', `${rect.top}px`);
        HTMLUtils.css(this.canvas, 'left', `${rect.left}px`);
        HTMLUtils.css(this.canvas, 'width', `${rect.width}px`);
        HTMLUtils.css(this.canvas, 'height', `${rect.height}px`);
        HTMLUtils.attr(this.canvas, 'width', `${rect.width}`);
        HTMLUtils.attr(this.canvas, 'height', `${rect.height}`);
    }

    hideCanvas() {
        this.container.getElement().querySelector<HTMLElement>('canvas#carman').style.display = 'none';
        this.container.getElement().querySelector<HTMLElement>('canvas#x').style.display = 'block';
    }

    showCanvasOnly() {
        this.container.getElement().querySelector<HTMLElement>('canvas#x').style.display = 'none';
        this.container.getElement().querySelector<HTMLElement>('canvas#carman').style.display = 'block';
    }

    public async apply(filterName: string) {
        const config: GLFXFilterConfig = GLFXFilters[filterName];
        // this.image = await this.photoModel.cloneXSource();
        // document.querySelector("#container img").replaceWith(this.image)
        // HPY 2019 this.image.hide();
        // Driver.showLoading();
        await this.applyFilterToCanvas(config);
        FilterConfig.setCurrentFilterConfig(config);
    }

    public async applyFilterToCanvas(config: GLFXFilterConfig) {
        const texture = this.canvas.texture(this.photoModel.getPersistedCanvas());
        let c = this.canvas.draw(texture);
        if (config.blur > 0) {
            c = c.triangleBlur(config.blur);
        } else {
            c = c.unsharpMask(3, -1 * config.blur / 20);
        }

        if (config.brightness || config.contrast) {
            c = c.brightnessContrast(config.brightness / 100, config.contrast / 100);
        }
        if (config.saturation) {
            c = c.saturation(config.saturation);
        }
        if (config.vignette) {
            c = c.vignette(.1, config.vignette / 100);
        }
        if (config.xpro) {
            let cur = GLFXFilterValueMap.curves['' + config.xpro];
            c = c.curves(cur.red, cur.green, cur.blue);
        }

        if (config.tint) {
            let l = GLFXFilterValueMap.tint['' + config.tint];
            c.colorize(l.color.r, l.color.g, l.color.b, l.amount / 100);
        }

        c.update();
    }

    public async applyFilterToSample(glfxCanvas: GLFXCanvas, config: GLFXFilterConfig, imageOrCanvas: HTMLImageElement | HTMLCanvasElement): Promise<HTMLCanvasElement> {
        if (!glfxCanvas) {
            glfxCanvas = fx.canvas();
        }
        glfxCanvas.width = imageOrCanvas.width;
        glfxCanvas.height = imageOrCanvas.height;
        if (this.texture) {
            this.texture.loadContentsOf(imageOrCanvas);
        } else {
            this.texture = glfxCanvas.texture(imageOrCanvas);
        }
        let c = glfxCanvas.draw(this.texture);
        if (config.blur > 0) {
            c = c.triangleBlur(config.blur);
        } else {
            c = c.unsharpMask(3, -1 * config.blur / 20);
        }

        if (config.brightness || config.contrast) {
            c = c.brightnessContrast(config.brightness / 100, config.contrast / 100);
        }
        if (config.saturation) {
            c = c.saturation(config.saturation);
        }
        if (config.vignette) {
            c = c.vignette(.1, config.vignette / 100);
        }
        if (config.xpro) {
            let cur = GLFXFilterValueMap.curves['' + config.xpro];
            c = c.curves(cur.red, cur.green, cur.blue);
        }

        if (config.tint) {
            let l = GLFXFilterValueMap.tint['' + config.tint];
            c.colorize(l.color.r, l.color.g, l.color.b, l.amount / 100);
        }

        c.update();
        // image.replaceWith(await CImage.canvasToImage(c));
        return glfxCanvas;
    }

    async updateYImage() {
        // This does not alter the Y image
        CCanvas.copyCanvas(this.photoModel.getPersistedCanvas(), this.photoModel.getEphemeralCanvas());
        CCanvas.applyFilter(this.canvas, FilterConfig.getCurrentFilterConfig(), this.photoModel.getEphemeralCanvas());
        return null;
    }

    public handleResizeEvent() {
        this.fitCanvasToContainer();
        this.showCanvasOnly();
    }

    public async finalize() {
        this.hideCanvas();
        this.updateYImage();
        /* HPY 2019
            if(Filter.isDirty()){
                config = FilterConfig.getCurrentFilterConfig();
                texture = Filter.canvas.texture(this.image);
                var c = Filter.canvas.draw(texture);
                if(config.blur > 0){
                    c = c.triangleBlur(config.blur);
                }else {
                    c = c.unsharpMask(3, -1 * config.blur / 20);
                }

                if(config.brightness || config.contrast){
                    c = c.brightnessContrast(config.brightness / 100, config.contrast/100);
                }
                if(config.saturation){
                    c = c.saturation(config.saturation);
                }
                if(config.vignette){
                    c = c.vignette(.1, config.vignette / 100);
                }
                if(config.xpro){
                    var cur = GLFXFilterValueMap.curves["" + config.xpro];
                    c = c.curves(cur.red, cur.green, cur.blue);
                }

                if(config.tint){
                    var l = GLFXFilterValueMap.tint["" + config.tint];
                    c.colorize(l.color.r, l.color.g, l.color.b, l.amount / 100);
                }

                c.update();
                this.photoModel.updateYSource(c.toDataURL('image/png'));
                this.container.getElement().find('img').show();
                this.container.getElement().find('canvas').hide();
                this.photoModel.updateSource(this.image);
                Filter.setDirty(false);
            }
            */
    }
}

